///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { GtthNotificationsService } from '../logical-topology/engine/notifications-service';
import { GtthConfirmationService } from '../logical-topology/engine/confirm-notification.service';
import { CustomConfirmationAction, GtthConfirmationMessage } from '../logical-topology/engine/gtth-notification-message';

@Component({
    selector: 'winde-alerts-container',
    templateUrl: './alerts-container.component.html',
    styleUrls: ['./alerts-container.scss'],
    standalone: false
})
export class GtthAlertsContainerComponent {
    constructor(
        public notificationService: GtthNotificationsService,
        public confirmService: GtthConfirmationService
    ) {}

    doAction(confirmation: GtthConfirmationMessage, action: CustomConfirmationAction) {
        action.callback();
        if (action.closeWindowAfterAction) {
            confirmation.onConfirmResult(true);
        }
    }
}
